import { PENDING, FULFILLED, REJECTED } from "redux-promise-middleware";
import {
  FETCH_AVAILABLE_GATEWAYS,
  FETCH_AVAILABLE_GATEWAY,
  CREATE_AVAILABLE_GATEWAY,
  UPDATE_AVAILABLE_GATEWAY,
  DELETE_AVAILABLE_GATEWAY,
} from "../actions/availableGateway";

const SINGLE_DATA_INITIAL_STATE = {
  data: {},
  error: null,
  loading: false
};
const MULTI_DATA_INITIAL_STATE = {
  data: [],
  error: null,
  loading: false
};

export function availableGateways(state = MULTI_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${FETCH_AVAILABLE_GATEWAYS}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_AVAILABLE_GATEWAYS}_${FULFILLED}`:
      return Object.assign({}, state, payload.data, {
        loading: false,
        error: null
      });
    case `${FETCH_AVAILABLE_GATEWAYS}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function availableGateway(state = SINGLE_DATA_INITIAL_STATE, { type, payload }) {
  switch (type) {
    case `${FETCH_AVAILABLE_GATEWAY}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_AVAILABLE_GATEWAY}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${FETCH_AVAILABLE_GATEWAY}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function createAvailableGateway(
  state = SINGLE_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${CREATE_AVAILABLE_GATEWAY}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${CREATE_AVAILABLE_GATEWAY}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${CREATE_AVAILABLE_GATEWAY}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function updateAvailableGateway(
  state = SINGLE_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${UPDATE_AVAILABLE_GATEWAY}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${UPDATE_AVAILABLE_GATEWAY}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${UPDATE_AVAILABLE_GATEWAY}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}

export function deleteAvailableGateway(
  state = SINGLE_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${DELETE_AVAILABLE_GATEWAY}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${DELETE_AVAILABLE_GATEWAY}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${DELETE_AVAILABLE_GATEWAY}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/availableGateway.js